import { DefaultTheme, ExecutionContext } from "styled-components";
export type ITheme = "light" | "dark";
export const appLayoutHeights = {
  header: 92,
};
export const screenSizes = {
  mobileS: "320px",
  mobileM: "375px",
  mobileL: "425px",
  tablet: "768px",
  laptop: "1024px",
  laptopL: "1440px",
  desktop: "2560px",
};
export const devices = {
  mobileS: `(min-width: ${screenSizes.mobileS})`,
  mobileM: `(min-width: ${screenSizes.mobileM})`,
  mobileL: `(min-width: ${screenSizes.mobileL})`,
  tablet: `(min-width: ${screenSizes.tablet})`,
  laptop: `(min-width: ${screenSizes.laptop})`,
  laptopL: `(min-width: ${screenSizes.laptopL})`,
  desktop: `(min-width: ${screenSizes.desktop})`,
  desktopL: `(min-width: ${screenSizes.desktop})`,
};

export interface IColorScheme {
  background: string;
  boxBg: string;
  textColor: string;
  highlight: string;
  textSecondary: string;
  primary: string;
  secondary: string;
  accent: string;
  success: string;
  fail: string;
}
export const colorScheme: Record<ITheme, IColorScheme> = {
  light: {
    background: "",
    highlight: "",
    boxBg: "#F1F0F1",
    textColor: "",
    textSecondary: "",
    primary: "#5575F7",
    secondary: "#FDFDFF",
    accent: "#8075FF",
    success: "",
    fail: "",
  },
  dark: {
    background: "",
    boxBg: "",
    textColor: "",
    textSecondary: "",
    primary: "",
    secondary: "",
    accent: "",
    success: "",
    fail: "",
    highlight: "",
  },
};
export type Colors = keyof IColorScheme;
export const getColor = (
  { theme: { colors } }: ExecutionContext,
  colorName: keyof IColorScheme
) => (colors as IColorScheme)[colorName];
export const getThemeColor = (theme: ITheme, colorName: keyof IColorScheme) => {
  return colorScheme[theme][colorName];
};
export type IVariant = "primary" | "secondary" | "accent" | "delete" | "text";
export interface AppTheme extends DefaultTheme {
  colors: IColorScheme;
}
export const appScreens = {
  xs: "480px",
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
}

// media 
export type Breakpoint = keyof typeof appScreens;
// export type Colors = keyof typeof colorScheme.light;

export const media = (breakpoint: Breakpoint) => 
  `@media (min-width: ${appScreens[breakpoint]})`;

export const min = (bp: Breakpoint) =>
  `@media (min-width: ${appScreens[bp]})`;

export const max = (bp: Breakpoint) =>
  `@media (max-width: ${appScreens[bp]})`;

export const between = (minBp: Breakpoint, maxBp: Breakpoint) =>
  `@media (min-width: ${appScreens[minBp]}) and (max-width: ${appScreens[maxBp]})`;
